import { render, staticRenderFns } from "./Balloon.vue?vue&type=template&id=147b63bf&scoped=true&"
import script from "./Balloon.vue?vue&type=script&lang=js&"
export * from "./Balloon.vue?vue&type=script&lang=js&"
import style0 from "./Balloon.vue?vue&type=style&index=0&id=147b63bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b63bf",
  null
  
)

export default component.exports